module.exports = __webpack_public_path__ + "img/dza.4be984a3.svg";